import Form, { FormData } from "../Components/Form/Form";
import { contactUsFormDefinition } from "../utilities/formDefinitionTemplates";
import Button, { ButtonProp } from "../Components/Button";
import { useContext, useState } from "react";
import { LangContext, LangContextType, LoadingContext, LoadingContextType, ToastContext, ToastContextType } from "../utilities/customHooks";
import { useNavigate } from "react-router-dom";
import { handleFormSaveResponse, returnLangCheckedFormDef } from "../utilities/helperFunctions";
import { sendContactEmail } from "../services/founderService";
import textData from "../textData.json";
import ioDark from '../assets/Invest-Ottawa-Logo-Colour-RGB-Transparent.png'
import nfDark from '../assets/NorthForge-PrimaryLogo-CMYK.png'
import leaf from '../assets/Group.png'
import ctLogoText from '../assets/Group-1.png'

const ContactUs = () => {

  const { langState, setLang } = useContext(LangContext) as LangContextType
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const navigate = useNavigate();
  const [isSent, setIsSent] = useState(false)
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  async function submitHelpRequest (updatedForm: FormData) {
    const emailDetails = {
      subject: updatedForm['subject'] as string,
      message: updatedForm['message'] as string,
      email: updatedForm['email'] as string
    }
    showLoading();
    const response = await sendContactEmail(emailDetails);
    hideLoading();
    
    if (response.success) 
      setIsSent(true)
      handleFormSaveResponse(
        response,
        showToast,
        {message: textData.Pages.Help.SuccessToast[langState], autoDisappearTimeInSeconds: 5},
        {message: textData.Pages.Help.FailToast[langState], autoDisappearTimeInSeconds: 5}
      )
    }
    
  const primaryButtonProp: ButtonProp = {
    buttonText: textData.Pages.Help.Submit[langState],
    actionHandler: submitHelpRequest,
  }

  const handleLangToggle = async () => {
    if (langState === "eng") {
      setLang("fr")
    }
    if (langState === "fr") {
      setLang("eng")
    }
  }

  return (
    <div className="h-full w-full">
      <div className='panewrapper bg-cGreen text-cWhite'>
        <header className='headerContact'>
          <h2 className="font-semibold" style={{color: "#FDFFFF"}}>{textData.Pages.LandingPage.pages.index.EIP[langState]}</h2>
          <div className='headerSect'>
            <button className='flex bodyLarger buttonSizer items-center justify-center' onClick={() => handleLangToggle()}>
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" className='mr-2 relative bottom-1'>
                <g id="Button Icons">
                  <circle id="Ellipse 114" cx="8" cy="8.5" r="7.5" stroke="#FDFFFE"/>
                  <path id="Ellipse 115" d="M10.5 8.5C10.5 10.6651 10.1701 12.6029 9.65316 13.9813C9.39401 14.6723 9.0975 15.1969 8.79361 15.5396C8.4892 15.883 8.21987 16 8 16C7.78013 16 7.5108 15.883 7.20639 15.5396C6.9025 15.1969 6.60599 14.6723 6.34684 13.9813C5.82994 12.6029 5.5 10.6651 5.5 8.5C5.5 6.33494 5.82994 4.39713 6.34684 3.01871C6.60599 2.32765 6.9025 1.80314 7.20639 1.46038C7.5108 1.11704 7.78013 1 8 1C8.21987 1 8.4892 1.11704 8.79361 1.46038C9.0975 1.80314 9.39401 2.32765 9.65316 3.01871C10.1701 4.39713 10.5 6.33494 10.5 8.5Z" stroke="#FDFFFE"/>
                  <path id="Vector 397" d="M0.5 8.5H15.5" stroke="#FDFFFE" strokeLinecap="round"/>
                </g>
              </svg>
              <span className='relative whiteButton'>{langState === "eng" ? "ENG" : "FR"}</span>
            </button>
            <Button
              style={"whiteButton"}
              buttonText={textData.Pages.LandingPage.pages.index.Login[langState]}
              buttonType='secondary'
              actionHandler={() => navigate("/login")}
            />
            <Button
              buttonText={textData.Pages.LandingPage.pages.index.Register[langState]}
              buttonType='primary'
              actionHandler={() => navigate("/register")}
            />
          </div>
        </header>
      </div>
      <div className="w-full h-full flex">
        <div className="twoThree w-2/3">
          {!isSent
          ?
          <div className="flex flex-col contactCont">
            <div>
              <h2 className="h1">{textData.Pages.ContactUs.ContactUs[langState]}</h2>
              <h2>{textData.Pages.ContactUs.Happy[langState]}</h2>
            </div>
            <Form 
              formDefinition={returnLangCheckedFormDef(contactUsFormDefinition, langState)} 
              formData={null}
              primaryButtonProp={primaryButtonProp}
              buttonFullWidth
            />
          </div>  
          :
          <div>
            <h2 className="h1 mb-4">{textData.Pages.ContactUs.ContactUs[langState]}</h2>
            <p className="bodyLarger mb-4">{textData.Pages.ContactUs.Thank[langState]}</p>
            <Button
              buttonText={textData.Pages.ContactUs.Another[langState]}
              buttonType="secondary"
              actionHandler={() => setIsSent(false)}
            />
          </div>
          }
        </div>
        <div className="oneThree w-1/3 ">
          <div className="flex flex-col contactLogoCont w-full h-full">
            <div>
              <a href='https://communitech.ca/' target="_blank" className='footerCTLogo flex'>
                <img
                  className="ctLogoLeaf"
                  src={leaf}
                  alt="communitech Logo leaf"
                />
                <img
                  className="ctLogoText"
                  src={ctLogoText}
                  alt="communitech Logo text"
                />
               </a>
               <p>151 Charles Street West, Suite 100</p>
               <p>Kitchener, Ontario, Canada</p>
               <p>N2G 1H6</p>
               <p className="flex">
                  <span className="mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.49909 0.836081C1.92704 2.10912 3.28833 3.27456 4.31657 4.14232C4.87282 4.61107 5.33115 4.99235 5.65142 5.25724C5.77102 5.35677 5.87135 5.43944 5.95001 5.50365C3.30358 7.67808 3.00419 7.9446 0.605777 10.0781C0.570458 10.1094 0.534338 10.1407 0.499022 10.1729C0.451664 7.91006 0.428387 6.70695 0.428387 5.50364C0.428387 4.30033 0.451732 3.09805 0.49909 0.836081ZM0.84905 10.4344C4.33755 10.4826 6.16924 10.5067 8.0001 10.5067C9.83421 10.5067 11.6684 10.4826 15.168 10.4344C12.6997 8.14926 12.4381 7.91809 9.71939 5.78126L8.70481 6.66982C8.30107 7.023 7.69907 7.023 7.29531 6.66982L6.28314 5.78447C3.58698 7.99979 3.30444 8.2511 0.892468 10.3957C0.87802 10.4086 0.863499 10.4216 0.84905 10.4344ZM6.42286 5.3375C6.42527 5.33911 6.42687 5.34071 6.42848 5.34232L7.57709 6.34726C7.8195 6.55915 8.1807 6.55915 8.42311 6.34726L9.57173 5.34232C9.57333 5.34071 9.57574 5.33911 9.57815 5.3375L9.60383 5.31663C9.62069 5.30218 9.64637 5.28131 9.68089 5.25322C9.74912 5.19703 9.85186 5.11355 9.98591 5.00278C10.2548 4.78044 10.6521 4.44974 11.1666 4.01549C12.1178 3.212 13.4703 2.05375 15.1495 0.572806C11.6619 0.524645 9.831 0.500566 8.00013 0.500566C6.16843 0.500566 4.33676 0.524647 0.846819 0.572806C2.24908 1.82096 3.58161 2.96238 4.59279 3.81473C5.14744 4.28268 5.60497 4.66315 5.92443 4.92724C6.08336 5.05888 6.20858 5.16162 6.29367 5.23146C6.33541 5.26597 6.36832 5.29326 6.38999 5.31092L6.42286 5.3375ZM15.5011 0.832998C13.7882 2.34604 12.4092 3.52669 11.4428 4.34308C10.9267 4.77813 10.5285 5.10964 10.2588 5.33277C10.1794 5.39779 10.1112 5.45397 10.055 5.50053C12.7335 7.60674 13.0072 7.85086 15.5019 10.1601C15.5485 7.90531 15.5718 6.70467 15.5718 5.50382C15.5718 4.30061 15.5485 3.09641 15.5011 0.832998ZM0.29116 0.152332C7.99928 0.0455768 8.00092 0.0455768 15.7088 0.152332C15.8236 0.153937 15.9175 0.247048 15.9199 0.361823C16.0267 5.50221 16.0267 5.5053 15.9199 10.6457C15.9175 10.7605 15.8236 10.8536 15.7088 10.8552C8.00072 10.9619 7.99908 10.9619 0.29116 10.8552C0.176379 10.8536 0.0824705 10.7605 0.0800664 10.6457C-0.0266888 5.5053 -0.0266888 5.50221 0.0800664 0.361823C0.0824744 0.247042 0.176387 0.153935 0.29116 0.152332Z" fill="black"/>
                    </svg>
                  </span>
                  <span className="contact-email">elevateip@communitech.ca</span>
                </p>
            </div>
            <div>
              <a href='https://www.investottawa.ca/' target="_blank">
                <img
                  className="ioLogoDark"
                  src={ioDark}
                  alt="Invest Ottawa Logo"
                />
              </a>
              <p>7 Bayview Station Road</p>
              <p>Ottawa, Ontario, Canada</p>
              <p>K1Y 2C5</p>
              <p className="flex">
                <span className="mr-2 inline">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.49909 0.836081C1.92704 2.10912 3.28833 3.27456 4.31657 4.14232C4.87282 4.61107 5.33115 4.99235 5.65142 5.25724C5.77102 5.35677 5.87135 5.43944 5.95001 5.50365C3.30358 7.67808 3.00419 7.9446 0.605777 10.0781C0.570458 10.1094 0.534338 10.1407 0.499022 10.1729C0.451664 7.91006 0.428387 6.70695 0.428387 5.50364C0.428387 4.30033 0.451732 3.09805 0.49909 0.836081ZM0.84905 10.4344C4.33755 10.4826 6.16924 10.5067 8.0001 10.5067C9.83421 10.5067 11.6684 10.4826 15.168 10.4344C12.6997 8.14926 12.4381 7.91809 9.71939 5.78126L8.70481 6.66982C8.30107 7.023 7.69907 7.023 7.29531 6.66982L6.28314 5.78447C3.58698 7.99979 3.30444 8.2511 0.892468 10.3957C0.87802 10.4086 0.863499 10.4216 0.84905 10.4344ZM6.42286 5.3375C6.42527 5.33911 6.42687 5.34071 6.42848 5.34232L7.57709 6.34726C7.8195 6.55915 8.1807 6.55915 8.42311 6.34726L9.57173 5.34232C9.57333 5.34071 9.57574 5.33911 9.57815 5.3375L9.60383 5.31663C9.62069 5.30218 9.64637 5.28131 9.68089 5.25322C9.74912 5.19703 9.85186 5.11355 9.98591 5.00278C10.2548 4.78044 10.6521 4.44974 11.1666 4.01549C12.1178 3.212 13.4703 2.05375 15.1495 0.572806C11.6619 0.524645 9.831 0.500566 8.00013 0.500566C6.16843 0.500566 4.33676 0.524647 0.846819 0.572806C2.24908 1.82096 3.58161 2.96238 4.59279 3.81473C5.14744 4.28268 5.60497 4.66315 5.92443 4.92724C6.08336 5.05888 6.20858 5.16162 6.29367 5.23146C6.33541 5.26597 6.36832 5.29326 6.38999 5.31092L6.42286 5.3375ZM15.5011 0.832998C13.7882 2.34604 12.4092 3.52669 11.4428 4.34308C10.9267 4.77813 10.5285 5.10964 10.2588 5.33277C10.1794 5.39779 10.1112 5.45397 10.055 5.50053C12.7335 7.60674 13.0072 7.85086 15.5019 10.1601C15.5485 7.90531 15.5718 6.70467 15.5718 5.50382C15.5718 4.30061 15.5485 3.09641 15.5011 0.832998ZM0.29116 0.152332C7.99928 0.0455768 8.00092 0.0455768 15.7088 0.152332C15.8236 0.153937 15.9175 0.247048 15.9199 0.361823C16.0267 5.50221 16.0267 5.5053 15.9199 10.6457C15.9175 10.7605 15.8236 10.8536 15.7088 10.8552C8.00072 10.9619 7.99908 10.9619 0.29116 10.8552C0.176379 10.8536 0.0824705 10.7605 0.0800664 10.6457C-0.0266888 5.5053 -0.0266888 5.50221 0.0800664 0.361823C0.0824744 0.247042 0.176387 0.153935 0.29116 0.152332Z" fill="black"/>
                  </svg>
                </span>
                <span className="contact-email">ip@investottawa.ca</span>
              </p>
            </div>
            <div>
              <a href='https://northforge.ca/' target="_blank">
                <img
                    className="nfLogoDark"
                    src={nfDark}
                    alt="North Forge Logo"
                  />
              </a>
              <p>441 - 100 Innovation Drive</p>
              <p>Winnipeg, Manitoba, Canada</p>
              <p>R3T 6G2</p>
              <p className="flex">
                <span className="mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.49909 0.836081C1.92704 2.10912 3.28833 3.27456 4.31657 4.14232C4.87282 4.61107 5.33115 4.99235 5.65142 5.25724C5.77102 5.35677 5.87135 5.43944 5.95001 5.50365C3.30358 7.67808 3.00419 7.9446 0.605777 10.0781C0.570458 10.1094 0.534338 10.1407 0.499022 10.1729C0.451664 7.91006 0.428387 6.70695 0.428387 5.50364C0.428387 4.30033 0.451732 3.09805 0.49909 0.836081ZM0.84905 10.4344C4.33755 10.4826 6.16924 10.5067 8.0001 10.5067C9.83421 10.5067 11.6684 10.4826 15.168 10.4344C12.6997 8.14926 12.4381 7.91809 9.71939 5.78126L8.70481 6.66982C8.30107 7.023 7.69907 7.023 7.29531 6.66982L6.28314 5.78447C3.58698 7.99979 3.30444 8.2511 0.892468 10.3957C0.87802 10.4086 0.863499 10.4216 0.84905 10.4344ZM6.42286 5.3375C6.42527 5.33911 6.42687 5.34071 6.42848 5.34232L7.57709 6.34726C7.8195 6.55915 8.1807 6.55915 8.42311 6.34726L9.57173 5.34232C9.57333 5.34071 9.57574 5.33911 9.57815 5.3375L9.60383 5.31663C9.62069 5.30218 9.64637 5.28131 9.68089 5.25322C9.74912 5.19703 9.85186 5.11355 9.98591 5.00278C10.2548 4.78044 10.6521 4.44974 11.1666 4.01549C12.1178 3.212 13.4703 2.05375 15.1495 0.572806C11.6619 0.524645 9.831 0.500566 8.00013 0.500566C6.16843 0.500566 4.33676 0.524647 0.846819 0.572806C2.24908 1.82096 3.58161 2.96238 4.59279 3.81473C5.14744 4.28268 5.60497 4.66315 5.92443 4.92724C6.08336 5.05888 6.20858 5.16162 6.29367 5.23146C6.33541 5.26597 6.36832 5.29326 6.38999 5.31092L6.42286 5.3375ZM15.5011 0.832998C13.7882 2.34604 12.4092 3.52669 11.4428 4.34308C10.9267 4.77813 10.5285 5.10964 10.2588 5.33277C10.1794 5.39779 10.1112 5.45397 10.055 5.50053C12.7335 7.60674 13.0072 7.85086 15.5019 10.1601C15.5485 7.90531 15.5718 6.70467 15.5718 5.50382C15.5718 4.30061 15.5485 3.09641 15.5011 0.832998ZM0.29116 0.152332C7.99928 0.0455768 8.00092 0.0455768 15.7088 0.152332C15.8236 0.153937 15.9175 0.247048 15.9199 0.361823C16.0267 5.50221 16.0267 5.5053 15.9199 10.6457C15.9175 10.7605 15.8236 10.8536 15.7088 10.8552C8.00072 10.9619 7.99908 10.9619 0.29116 10.8552C0.176379 10.8536 0.0824705 10.7605 0.0800664 10.6457C-0.0266888 5.5053 -0.0266888 5.50221 0.0800664 0.361823C0.0824744 0.247042 0.176387 0.153935 0.29116 0.152332Z" fill="black"/>
                  </svg>
                </span>
                <span className="contact-email">info@northforge.ca</span>
              </p>
            </div>
          </div>  
        </div>
      </div>
    </div>
  )
}

export default ContactUs